/**
 * 环境配置
 */
import store from "../store";

// 当前环境 取当前的环境，如果取不到，默认取线上环境
const env = import.meta.env.MODE || 'prod'
console.log(env);
const EnvConfig = {
  // 开发环境
  development: {
    baseApi: '/JCloud',
    mockApi: 'https://saas.solareastiot.com/JCloud',
  },
  // 线上环境
  production: {
    baseApi: '/JCloud',
    mockApi: 'https://saas.solareastiot.com/JCloud',
  }
}
const mockApi = EnvConfig.development.mockApi
store.commit('setAPI', mockApi)
console.log(store.state.mockApi);
export default {
  env,
  // mock的总开关
  mock: false,
  ...EnvConfig[env]
}